/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PowSolution } from './PowSolution';
const CreateOTPLoginDataParser = /* #__PURE__ */ parsers.object([
    ['email', codecString],
    ['tenantId', /* #__PURE__ */ codecOptional(codecString), 'tenant_id'],
    ['pow', PowSolution],
]);
export class CreateOTPLoginData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateOTPLoginDataParser.decode(input).map(res => new CreateOTPLoginData(res));
    }
    static unsafeDecode(input) {
        return CreateOTPLoginData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateOTPLoginDataParser.encode(data);
    }
    static schema() {
        return CreateOTPLoginDataParser.schema();
    }
}
